import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Guards every shell route other than /dashboard. A registered account that
 * still needs to pick a plan or complete its profile is confined to the
 * dashboard (where the corresponding overlay/CTA is shown) until it does.
 */
export const onboardingRestrictedGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.needsPlanSelection() || auth.needsProfileCompletion()) {
    return router.createUrlTree(['/dashboard']);
  }
  return true;
};
